"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prepareGatewayResumeStartup;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** Prepare the opt-in startup handoff only for the ordinary built-in Welcome flow. */
function prepareGatewayResumeStartup(state, api, startupName, extraStartupScreens) {
  var _context;
  if (startupName !== 'welcome' || extraStartupScreens.welcome || state.settings.startupOptions.bouncer || state.settings.startupOptions.altComponent || !api.prepareGatewayResumeStartup) {
    return null;
  }
  var connection = Misc.connectionInfoFromConfig(state.settings.startupOptions);

  // Kiwi restores saved networks on every reload. Welcome reuses the first one with the
  // configured address, so the resume can only take it over when it targets the same port.
  var address = String(connection.hostname || '').toLowerCase();
  var reused = (0, _find.default)(_context = state.networks).call(_context, function (network) {
    var server = String(network.connection.server || '').toLowerCase();
    return server === address;
  });
  if (reused && Number(reused.connection.port) !== Number(connection.port)) {
    return null;
  }
  return api.prepareGatewayResumeStartup({
    startupName: startupName,
    connection: connection
  });
}